import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import { AppRoutes } from "@/app/routes";
import { queryClient } from "@/lib/query-client";
import { registerSignOutHandler } from "@/lib/api";
import { useTheme } from "@/hooks/useTheme";
import { signOut } from "aws-amplify/auth";

registerSignOutHandler(async () => {
  try {
    await signOut();
  } catch {
    /* already signed out */
  }
});

export function App() {
  const { resolved } = useTheme();

  // Refresh the resolved theme attribute if it was somehow lost (e.g., after a
  // route HMR reload). The inline bootstrap in index.html handles first paint.
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", resolved);
  }, [resolved]);

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <Toaster
        position="top-right"
        theme={resolved}
        richColors
        closeButton
        toastOptions={{ duration: 4_000 }}
      />
    </QueryClientProvider>
  );
}
